import lookupReservation from '../components/lookup-reservation/lookup-reservation.vue'
import modifyReservationDetail from '../components/modify-reservation-detail/modify-reservation-detail.vue'

export const BOOKING_MODIFY_ROUTE_NAMES = Object.freeze({
  ROOT: '/find-reservation',
  LOOKUP_RESERVATION: 'lookup-reservation',
  MODIFY_RESERVATION_DETAIL: 'modify-reservation-detail',
})

export const bookingModifyRoutes = [
  { path: `${BOOKING_MODIFY_ROUTE_NAMES.ROOT}`, component: lookupReservation, name: BOOKING_MODIFY_ROUTE_NAMES.LOOKUP_RESERVATION },
  { path: `${BOOKING_MODIFY_ROUTE_NAMES.ROOT}/details`, component: modifyReservationDetail, name: BOOKING_MODIFY_ROUTE_NAMES.MODIFY_RESERVATION_DETAIL },
]
